
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planner",
      function () {
        return require("private-next-pages/planner/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planner"])
      });
    }
  